import React from "react";
import { authService, translateService } from "../../services/imports";
import { Link } from "../../components/routing/imports";
import oidcService from "../../services/oidcService";

// Keycloak redirect_uri page. The code exchange itself runs before the app
// renders (authService.init in main.js); this page only navigates to the
// requested page through the router, or shows why the login failed.
// It never restarts a login.
export default class OidcCallbackPage extends React.Component {
  componentDidMount() {
    if (this.failed()) return;
    const target = oidcService.postLoginTarget || globalConfig.base_URL + "dashboard";
    oidcService.postLoginTarget = null;
    this.props.history.replace(target);
  }

  failed() {
    const params = new URLSearchParams(window.location.search);
    return !!authService.callbackError || !!params.get("error") || !authService.isAuthenticated();
  }

  render() {
    const params = new URLSearchParams(window.location.search);
    const error = authService.callbackError;
    const failed = this.failed();
    const detail =
      params.get("error_description") ||
      (error && (error.error_description || error.message)) ||
      "";

    return (
      <div className="registration container oidc-callback">
        <div className="row row-right">
          <div className="item-right">
            <div className="form">
              <span className="title">
                {translateService.t(failed ? "signing.loginFailed" : "signing.signingYouIn")}
              </span>
              {failed && detail && <div className="detail color-three">{detail}</div>}
              {failed && (
                <div className="buttons login-buttons">
                  <Link to="landing" className="button background-color-two color-white">
                    {translateService.t("signing.backToStart")}
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
